(function () {
  'use strict';

  angular
    .module('app.category.filters', ['rzModule'])

    .directive('filters', function () {
      return {
        restrict: 'E',
        scope: true,
        bindToController: {
          idCategory: '<',
          scroll: '<',
          device: '<'
        },
        controllerAs: 'filtersCtrl',
        /* @ngInject */
        controller: ["$scope", "$rootScope", "$timeout", "$location", "$document", "AppService", "CategoryFiltersCacheService", "CategoryService", "smoothScroll", function ($scope, $rootScope, $timeout, $location, $document, AppService, CategoryFiltersCacheService, CategoryService, smoothScroll) {
          if (window.isBot || window.isCache) return;
          var ctrl = this;

          ctrl.search = '';
          ctrl.words = [];
          ctrl.selected = [];
          ctrl.filters = null;
          ctrl.BrandsSelected = [];
          ctrl.FacetsSelected = [];
          ctrl.ReviewsSelected = [];
          ctrl.ProductTypesSelected = [];

          ctrl.$onInit = function () {
            get();
          };

          ctrl.submitSearch = function (event) {
            if (ctrl.search === '') return;

            if (typeof event === 'undefined') {
              addWord(ctrl.search);
            } else if (event && event.which === 13) {
              event.preventDefault();
              $(event.target).blur();
              addWord(ctrl.search);
            }
          };
          ctrl.removeWord = function (word) {
            _.pull(ctrl.words, word);
            updateUrl();
          };

          ctrl.openDropdown = function (event) {
            var $button = $(event.currentTarget),
              $menu = $button.siblings('.dropdown-menu');
            if ($button.parent().hasClass('open')) {
              $menu.removeAttr('style');
            } else {
              if (ctrl.device.xxs) {
                $menu.css({
                  left: $button.offset().left * -1 + 10,
                  width: $(document.body).width() - 20
                });
              } else {
                $menu.removeClass('dropdown-menu-right').show();
                if ($menu.offset().left + $menu.width() > $(document.body).width()) {
                  $menu.addClass('dropdown-menu-right');
                }
                $menu.removeAttr('style');
              }

              $timeout(function () {
                $rootScope.$broadcast('rzSliderForceRender');
              }, 10);

              var closeDropdown = function () {
                $menu.removeAttr('style');
                $document.off('click', closeDropdown);
              };

              $menu.find('.rzslider').removeClass('opened');
              $timeout(function () {
                $rootScope.$broadcast('rzSliderForceRender');
                $menu.find('.rzslider').addClass('opened');
                $document.on('click', closeDropdown);
              }, 500);

            }
          };

          ctrl.setFacet = function (item, itemValue, initCheck) {
            var facet = _.find(ctrl.FacetsSelected, { 'Id': item.Id });
            if (item.isColor) {
              itemValue.selected = !itemValue.selected;
            }
            if (itemValue.selected) {
              facet.Values.push(itemValue.Value);
              ctrl.selected.push({
                id: itemValue.ref,
                name: itemValue.selectedValue,
                value: itemValue.Value,
                type: item.Id,
                selectId: 'f' + item.Id
              });
            } else {
              _.pull(facet.Values, itemValue.Value);
              _.remove(ctrl.selected, function (elem) {
                return elem.selectId === 'f' + item.Id && elem.id === itemValue.ref;
              });
            }
            if (!initCheck) {
              updateUrl();
            }
          };
          ctrl.setBrand = function (item) {
            selectFilter(item, 'b', ctrl.BrandsSelected, false);
          };
          ctrl.setReview = function (item) {
            selectFilter(item, 'r', ctrl.ReviewsSelected, true);
          };
          ctrl.setType = function (item) {
            selectFilter(item, 't', ctrl.ProductTypesSelected, false);
          };

          ctrl.removeFilter = function (item) {
            switch (item.type) {
              case 'b':
                _.pullAllBy(ctrl.BrandsSelected, [{ Id: item.id }], 'Id');
                break;
              case 'r':
                _.pull(ctrl.ReviewsSelected, String(item.id));
                break;
              case 't':
                _.pullAllBy(ctrl.ProductTypesSelected, [{ Id: item.id }], 'Id');
                break;
              case 'p':
                ctrl.PriceRange = null;
                break;
              default:
                _.pull(_.find(ctrl.FacetsSelected, { Id: item.type }).Values, item.value);
                break;
            }
            _.remove(ctrl.selected, function (elem) {
              return elem.selectId === item.selectId && elem.id === item.id;
            });
            updateUrl();
          };

          ctrl.removeFilters = function () {
            ctrl.selected = [];
            ctrl.words = [];
            ctrl.BrandsSelected = [];
            ctrl.ReviewsSelected = [];
            ctrl.ProductTypesSelected = [];
            _.each(ctrl.FacetsSelected, function (item) {
              item.Values = [];
            });
            ctrl.PriceRange = null;
            updateUrl();
          };

          // Functions

          function addWord(str, initCheck) {
            initCheck = initCheck || false;
            ctrl.search = '';
            ctrl.words.push(str);
            if (!initCheck) {
              updateUrl();
            }
          }

          function selectFilter(item, type, target, isReview, initCheck) {
            initCheck = initCheck || false;
            if (isReview) {
              if (item.selected) {
                target.push(String(item.Name));
                ctrl.selected.push({
                  id: item.Name,
                  name: item.Name,
                  type: type,
                  selectId: type + item.Name,
                  isReview: true
                });
              } else {
                _.pull(target, String(item.Name));
                _.pullAllBy(ctrl.selected, [{ selectId: type + item.Name }], 'selectId');
              }
            } else if (item.selected) {
              target.push({ Id: item.Id });
              ctrl.selected.push({
                id: item.Id,
                name: item.Name,
                type: type,
                selectId: type + item.Id,
                isReview: false
              });
            } else {
              _.pullAllBy(target, [{ Id: item.Id }], 'Id');
              _.pullAllBy(ctrl.selected, [{ selectId: type + item.Id }], 'selectId');
            }

            if (!initCheck) {
              updateUrl();
            }
          }

          function selectPrices(min, max) {
            ctrl.PriceRange = null;
            _.pullAllBy(ctrl.selected, [{ isPrices: true }], 'isPrices');
            ctrl.filters.prices.selectedMinPrice = min >= ctrl.filters.prices.minPrice ? min : ctrl.filters.prices.minPrice;
            ctrl.filters.prices.selectedMaxPrice = max <= ctrl.filters.prices.maxPrice ? max : ctrl.filters.prices.maxPrice;

            if (min !== ctrl.filters.prices.minPrice || max !== ctrl.filters.prices.maxPrice) {
              ctrl.PriceRange = {
                Gte: min,
                Lte: max
              };
              ctrl.selected.push({
                id: min + ',' + max,
                name: 'de ' + min + ' € à ' + max + ' €',
                type: 'p',
                selectId: min + ',' + max,
                isPrices: true
              });
            }
            $document.click();
          }

          function updateUrl() {
            var object = _.reduce(ctrl.selected, function (result, item) {
              (result['f' + item.type] || (result['f' + item.type] = [])).push(item.id);
              return result;
            }, {});

            var params = {};
            _.each(object, function (item, key) {
              params[key] = item.join(',');
            });

            if (ctrl.words.length) {
              params.fs = _.replace(_.deburr(ctrl.words.join(',')), / /g, '|');
            }

            $location.search(params).replace();
          }

          function get() {
            var gridCtrl = CategoryService.getGridCtrl();
            if (gridCtrl.api.filtered) {
              ctrl.noScroll = true;
            }

            var cache = CategoryFiltersCacheService.get('filters_' + ctrl.idCategory);
            if (cache) {
              getResults(_.cloneDeep(cache));
              return;
            }

            ctrl.loading = true;

            CategoryService.getFilters(String(ctrl.idCategory))
              .then(function (data) {
                ctrl.loading = false;
                CategoryFiltersCacheService.set('filters_' + ctrl.idCategory, _.cloneDeep(data));
                getResults(data);
              })
              .catch(function (error) {
                console.error(error);
              });
          }

          function getResults(data) {
            if (!data) return;
            if (!ctrl.FacetsSelected.length) {
              _.each(data.facets, function (item) {
                ctrl.FacetsSelected.push({ 'Id': item.Id, 'Name': item.Name, 'Key': item.Key, 'Values': [] });
              });
            }
            setDataFilters(data, true);
          }

          function set() {
            if (!ctrl.noScroll && ctrl.scroll && $('#topGridProducts').offset().top < 10) {
              smoothScroll(document.getElementById('topGridProducts'), { offset: 60 });
            }
            ctrl.noScroll = false;

            var gridCtrl = CategoryService.getGridCtrl();
            gridCtrl.api.items = [];
            gridCtrl.api.page = 1;
            gridCtrl.noresult = false;

            var facets = _.filter(ctrl.FacetsSelected, function (item) {
              return item.Values.length;
            });
            var brands = ctrl.BrandsSelected;
            var reviews = ctrl.ReviewsSelected;
            var types = ctrl.ProductTypesSelected;
            var search = !ctrl.words.length ? '' : ctrl.words.join(' ');
            var prices = ctrl.PriceRange || {};

            ctrl.removeAllEnabled = ctrl.selected.length + ctrl.words.length > 1;

            if (!facets.length && !brands.length && !reviews.length && !types.length && search === '' && _.isEmpty(prices)) {
              gridCtrl.nbProducts = gridCtrl.totalProducts;
              gridCtrl.api.maxPage = gridCtrl.maxPage;
              gridCtrl.api.busy = false;
              gridCtrl.api.filtered = false;

              ctrl.FacetsSelected = [];

              $timeout(function () {
                gridCtrl.loaded(true);
              });

              get();

              return;
            }

            $timeout(function () {
              $rootScope.$broadcast('showPageLoader', true);
            });

            gridCtrl.api.busy = true;
            gridCtrl.reload = true;
            gridCtrl.api.filtered = true;
            gridCtrl.api.filteredActive = false;

            gridCtrl.api.facets = facets;
            gridCtrl.api.brands = brands;
            gridCtrl.api.reviews = reviews;
            gridCtrl.api.types = types;
            gridCtrl.api.prices = prices;

            CategoryService.getProducts(1, true, gridCtrl.sort, facets, brands, reviews, types, prices, search, ctrl.idCategory, gridCtrl.nbPerPage)
              .then(function (data) {
                gridCtrl.api.items = gridCtrl.api.items.concat(data.products);
                gridCtrl.api.filteredActive = true;
                gridCtrl.api.busy = false;
                gridCtrl.reload = false;
                gridCtrl.nbProducts = data.total;
                gridCtrl.noresult = gridCtrl.nbProducts === 0 ? true : false;

                gridCtrl.api.maxPage = Math.ceil(gridCtrl.nbProducts / gridCtrl.nbPerPage) ? Math.ceil(gridCtrl.nbProducts / gridCtrl.nbPerPage) : 1;

                $timeout(function () {
                  $rootScope.$broadcast('showPageLoader', false);
                });

                setDataFilters(data, false);

              })
              .catch(function (error) {
                console.error(error);
              });
          }

          function setDataFilters(data, initCheck) {
            AppService.getTranslate()
              .then(function (translate) {
                ctrl.filters = ctrl.filters || {};
                ctrl.filters.brands = data.brands;
                ctrl.filters.facets = data.facets;
                ctrl.filters.reviews = data.reviews;
                ctrl.filters.types = data.types;
                ctrl.filters.products = data.products;
                ctrl.filters.total = data.total;
                if (!ctrl.filters.prices) {
                  ctrl.filters.prices = data.prices;
                } else {
                  ctrl.filters.prices.minPrice = data.prices.minPrice;
                  ctrl.filters.prices.maxPrice = data.prices.maxPrice;
                }

                ctrl.filters.pricesActive = false;
                if (ctrl.filters.prices.minPrice !== ctrl.filters.prices.maxPrice) {
                  ctrl.filters.prices.minPrice = Math.floor(ctrl.filters.prices.minPrice / 10) * 10;
                  ctrl.filters.prices.maxPrice = Math.ceil(ctrl.filters.prices.maxPrice / 10) * 10;
                  if (!ctrl.PriceRange) {
                    ctrl.filters.prices.selectedMinPrice = ctrl.filters.prices.minPrice;
                    ctrl.filters.prices.selectedMaxPrice = ctrl.filters.prices.maxPrice;
                  }

                  if (ctrl.filters.prices.selectedMinPrice < ctrl.filters.prices.minPrice) {
                    ctrl.filters.prices.selectedMinPrice = ctrl.filters.prices.minPrice;
                  }
                  if (ctrl.filters.prices.selectedMaxPrice > ctrl.filters.prices.maxPrice) {
                    ctrl.filters.prices.selectedMaxPrice = ctrl.filters.prices.maxPrice;
                  }

                  var startMin,
                    startMax;
                  ctrl.filters.prices.options = {
                    floor: ctrl.filters.prices.minPrice,
                    ceil: ctrl.filters.prices.maxPrice,
                    step: 10,
                    minRange: 10,
                    translate: function (value) {
                      return value + ' €';
                    },
                    onStart: function () {
                      startMin = ctrl.filters.prices.selectedMinPrice;
                      startMax = ctrl.filters.prices.selectedMaxPrice;
                    },
                    // eslint-disable-next-line
                    onEnd: function (sliderId, min, max) {
                      if (min !== startMin || max !== startMax) {
                        selectPrices(min, max);
                        updateUrl();
                      }
                      startMin = null;
                      startMax = null;
                    }
                  };
                  ctrl.filters.pricesActive = true;
                }

                if (ctrl.filters.facets.length || ctrl.filters.brands.length || ctrl.filters.reviews.length || ctrl.filters.types.length) {
                  ctrl.filters.reviews = _.filter(ctrl.filters.reviews, function (item) {
                    return item.Name > 0;
                  });
                  ctrl.filters.brands.selectedCount = 0;
                  ctrl.filters.reviews.selectedCount = 0;
                  ctrl.filters.types.selectedCount = 0;

                  _.each(ctrl.filters.facets, function (item) {
                    item.selectedCount = 0;
                    _.each(item.Values, function (itemValue) {
                      itemValue.checkValue = itemValue.Value;
                      itemValue.selectedValue = itemValue.Value;
                      itemValue.ref = _.camelCase(itemValue.Value);
                      itemValue.selected = false;
                      if (item.Name.indexOf('Couleur') !== -1) {
                        item.isColor = true;
                        itemValue.colorImg = '/img/colors/21x21/' + _.kebabCase(itemValue.Value) + '.png';
                      }
                      if (item.Type === 'Vrai/Faux') {
                        itemValue.checkValue = parseInt(itemValue.Value) === 0 ? translate.messages.No : translate.messages.Yes;
                        itemValue.selectedValue = parseInt(itemValue.Value) === 0 ? item.Name + translate.messages.Colon + ' ' + translate.messages.No : item.Name + translate.messages.Colon + ' ' + translate.messages.Yes;
                        itemValue.ref = _.camelCase(itemValue.checkValue);
                      }
                    });
                  });

                  var locSearch = {};
                  _.each($location.search(), function (value, key) {
                    if (key.indexOf('f') === 0) {
                      locSearch[key] = value;
                    }
                  });
                  if (!_.isEmpty(locSearch)) {
                    _.each(locSearch, function (value, key) {
                      if (key === 'fb') {
                        _.each(ctrl.filters.brands, function (item) {
                          item.selected = _.includes(value.split(','), String(item.Id));
                          if (item.selected) {
                            ctrl.filters.brands.selectedCount += 1;
                            if (initCheck) {
                              selectFilter(item, 'b', ctrl.BrandsSelected, false, true);
                            }
                          }
                        });
                      } else if (key === 'fr') {
                        _.each(ctrl.filters.reviews, function (item) {
                          item.selected = _.includes(value.split(','), String(item.Name));
                          if (item.selected) {
                            ctrl.filters.reviews.selectedCount += 1;
                            if (initCheck) {
                              selectFilter(item, 'r', ctrl.ReviewsSelected, true, true);
                            }
                          }
                        });
                      } else if (key === 'ft') {
                        _.each(ctrl.filters.types, function (item) {
                          item.selected = _.includes(value.split(','), String(item.Id));
                          if (item.selected) {
                            ctrl.filters.types.selectedCount += 1;
                            if (initCheck) {
                              selectFilter(item, 't', ctrl.ProductTypesSelected, false, true);
                            }
                          }
                        });
                      } else if (key === 'fp') {
                        if (initCheck) {
                          var arr = value.split(',');
                          selectPrices(Number(arr[0]), Number(arr[1]));
                        }
                      } else if (key !== 'fs' && key.indexOf('f') === 0) {
                        var item = _.find(ctrl.filters.facets, { Id: parseInt(key.slice(1)) });
                        _.each(item.Values, function (itemValue) {
                          itemValue.selected = _.includes(value.split(','), String(itemValue.ref));
                          if (itemValue.selected) {
                            item.selectedCount += 1;
                            if (initCheck) {
                              itemValue.selected = item.isColor ? !itemValue.selected : itemValue.selected;
                              ctrl.setFacet(item, itemValue, true);
                            }
                          }
                        });
                      }
                    });

                    if (!locSearch.c && !locSearch.q && !locSearch.p && initCheck && ctrl.selected.length) {
                      set();
                    }
                  }

                }

                if ($location.search().fs !== undefined) {
                  ctrl.words = _.replace($location.search().fs, /\|/g, ' ').split(',');
                }

                ctrl.active = true;

                $timeout.cancel(ctrl.timeout);
                $rootScope.$broadcast('showPageLoader', true);
                ctrl.timeout = $timeout(function () {
                  $rootScope.$broadcast('showPageLoader', false);
                }, 400);

                // gestion colonnage
                // ///////////////////////////////////////////////////////////////////////////

                ctrl.nbCols = ctrl.filters.brands.length ? 1 : 0;
                ctrl.nbCols = ctrl.filters.types.length ? ctrl.nbCols + 1 : ctrl.nbCols;
                ctrl.nbCols = ctrl.filters.prices.length ? ctrl.nbCols + 1 : ctrl.nbCols;
                ctrl.nbCols = ctrl.filters.reviews.length ? ctrl.nbCols + 1 : ctrl.nbCols;
                ctrl.nbCols = ctrl.filters.pricesActive ? ctrl.nbCols + 1 : ctrl.nbCols;
                ctrl.nbCols += ctrl.filters.facets.length;

                console.log('ctrl.nbCols' + ctrl.nbCols);

                if (ctrl.device.size === 'xl' && ctrl.nbCols > 7) {


                  ctrl.nbColsActive = true;
                  ctrl.nbColsActiveXL = true;
                  // number of lines XL
                  // ctrl.nbColsActiveLinesXL = Math.ceil(ctrl.nbCols / 7);
                  // ctrl.nbColsActiveLinesNumberXL = 'xl-lines' + ctrl.nbColsActiveLinesXL;

                } else if (ctrl.device.size === 'lg' && ctrl.nbCols > 5) {

                  ctrl.nbColsActive = true;
                  ctrl.nbColsActiveLG = true;
                  // number of lines LG
                  // ctrl.nbColsActiveLinesLG = Math.ceil(ctrl.nbCols / 5);
                  // ctrl.nbColsActiveLinesNumberLG = 'lg-lines' + ctrl.nbColsActiveLinesLG;

                } else if (ctrl.device.size === 'md' && ctrl.nbCols > 4) {

                  ctrl.nbColsActive = true;
                  ctrl.nbColsActiveMD = true;
                  // number of lines LG
                  // ctrl.nbColsActiveLinesMD = Math.ceil(ctrl.nbCols / 4);
                  // ctrl.nbColsActiveLinesNumberMD = 'md-lines' + ctrl.nbColsActiveLinesMD;
                } else {

                  ctrl.nbColsActive = false;
                  ctrl.nbColsActiveXL = false;
                  ctrl.nbColsActiveLG = false;
                  ctrl.nbColsActiveMD = false;
                  // ctrl.nbColsActiveLinesNumberXL = 'xl-lines1';
                  // ctrl.nbColsActiveLinesNumberSM = 'sm-lines1';

                }

                ctrl.setNbColsActive = function () {
                  ctrl.nbColsActive = !ctrl.nbColsActive;
                };
                // fin gestion colonnage
              })
              .catch(function (error) {
                console.error(error);
              });
          }

        }]
      };
    });

})();
